<template>
  <div class="thumbnail-wrap">
    <div
      v-if="isProductExist"
      class="product-thumbnail"
    >
      <div class="picture-wrap">
        <Picture
          :image-url="imageUrl"
          :image-intrinsic-width="100"
          :aspect-ratio="0.8"
          :set-scene7-hei="true"
          :alt="product.detail?.name"
        />
      </div>
      <div class="description-wrap">
        <div class="product-name-wrap">
          <p class="heavy">
            {{ product.detail?.brand?.name }}
          </p>
          <p>{{ product.detail?.name }}</p>
        </div>
        <p
          v-if="selectedColor"
          class="product-color"
          data-testid="selected-color"
        >
          Color: {{ selectedColor }}
        </p>
        <p
          v-if="selectedSize"
          class="product-size"
          data-testid="selected-size"
        >
          Size: {{ selectedSize }}
        </p>
      </div>
    </div>
  </div>
  <div
    v-if="!isAddToWishlistSuccess"
    data-testid="wrapper-notification"
    class="error-message-wrap"
  >
    <Notification
      severity="error"
      :closable="false"
    >
      Sorry, we’re unable to add this to your Wish List at
      this time.
    </Notification>
  </div>
  <p
    v-if="isAddToWishlistSuccess && !isSignedIn"
    class="message-wrap"
  >
    <a
      class="medium"
      href="#"
    >Sign in</a> to save this list permanently.
  </p>
  <div class="button-wrap">
    <button class="button primary expanded">
      view wish list
    </button>
    <button
      class="button secondary expanded"
      data-testid="btn-continue-shopping"
      @click="onClickContinueShopping"
    >
      continue shopping
    </button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Notification from '@atomic-ui/notification';
import Picture from '@atomic-ui/picture';

export default {
  name: 'StepConfirmation',
  components: { Notification, Picture },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    isAddToWishlistSuccess: {
      type: Boolean,
      default: true,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    selectedUpcId: {
      type: Number,
      default: 0,
    },
    isSignedIn: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close-slideout'],
  computed: {
    isProductExist() {
      return Object.values(this.product).length > 0;
    },
    imageUrl() {
      const colorId = this.product?.relationships?.upcs[this.selectedUpcId]?.traits?.colors?.selectedColor;
      let filePath = `/${this.product.imagery.images[0].filePath}`;
      if (colorId && this.isMultiple) {
        filePath = this.product.traits.colors.colorMap.filter((color) => color.id === colorId)[0].imagery.primaryImage.filePath;
      }
      return this.product?.urlTemplate.product + filePath;
    },
    selectedColor() {
      if (this.isMultiple && this.selectedUpcId) {
        const colorId = this.product?.relationships?.upcs[this.selectedUpcId]?.traits?.colors?.selectedColor;
        return colorId ? this.product.traits.colors.colorMap.filter((color) => color.id === colorId)[0].name : undefined;
      }
      return undefined;
    },
    selectedSize() {
      if (this.isMultiple && this.selectedUpcId) {
        const sizeId = this.product.relationships?.upcs[this.selectedUpcId].traits.sizes.selectedSize;
        return typeof sizeId === 'number' ? this.product.traits?.sizes?.sizeMap[sizeId.toString()]?.displayName : undefined;
      }
      return undefined;
    },
  },
  methods: {
    ...mapMutations({
      toggle: 'slideoutStore/TOGGLE',
    }),
    onClickContinueShopping() {
      this.toggle('wishlistDrawer');
      this.$emit('close-slideout');
    },
  },
};
</script>
<style lang="scss" scoped>
.thumbnail-wrap {
  margin-bottom: rem-calc(32);

  .expand {
    display: none;
  }
}

.button-wrap {
  margin-top: rem-calc(24);
}

:deep(.product-thumbnail) {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: rem-calc(32);

  .picture-wrap {
    flex-shrink: 0;
    min-height: rem-calc(125);
    aspect-ratio: 0.8;
  }
}
</style>
